export default {"src":"/_next/static/media/pl.41a08591.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};